import {IChatService} from "@app/services/ichat.service";
import {ITicket} from "@shared/models/ticket";
import {from, Observable} from "rxjs";
import {ChatMessage, IChatMessage} from "@app/models/chat";
import {Assistance} from "../../models/assistance";
import {filter, map, take, tap} from "rxjs/operators";
import {FirebaseOperationChat, FirebaseUser} from "@app/models/FirebaseModels";
import {AngularFireDatabase, AngularFireList} from "@angular/fire/database";
import {chatConfigs} from "@app/config";
import {database} from "firebase";
import {FirebaseService} from "@shared/firebase/firebase.service";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ChatFirebaseServiceImpl implements IChatService {

  chatId: string;
  private basePath: string;
  private chatPath: string;
  private messagesPath: string;
  private usersPath: string;
  private messages: AngularFireList<ChatMessage>;
  private parseMessages: ChatMessage[];
  chatMessages: Map<string, IChatMessage>;
  perPage = chatConfigs.messagePerPage;
  lastKey: number;

  constructor(
    private db: AngularFireDatabase,
    private firebaseService: FirebaseService,
  ) { }

  init(id: string) {
    this.basePath =  chatConfigs.chatBasePath;
    this.chatPath = this.basePath + id + chatConfigs.chatConstant;
    this.messagesPath = this.chatPath + chatConfigs.chatMessages;
    this.usersPath = this.chatPath + chatConfigs.chatUserPath;
    this.chatMessages = undefined;
    this.lastKey = undefined;
    this.chatId = `ticket_${id}`;
  }

  createOperationChatIfNotExits(operation: ITicket): Observable<any> {
    return from(this.db.database.ref(`${this.basePath}${operation.id}`).once('value')).pipe(
      take(1),
      tap((check) => {
        if (check.val() === null) {
          const chat = new FirebaseOperationChat(operation);
          return this.db.database.ref(this.chatPath).update(chat);
        }
      })
    );
  }

  async getChatMessages(): Promise<Observable<Array<IChatMessage>>> {
    this.messages = this.db.list(this.messagesPath,
      ref => ref.orderByChild('sentAt') // TODO add '.limitToLast(this.perPage)' and pagination
    );

    return this.messages.valueChanges().pipe(
      filter((messages) => messages.filter((item) => item.messageID === '-1').length === 0),
      map((messages) => {
        if (!messages.length) {
          return [];
        }
        this.setLastKeyValue(messages);
        this.chatMessages = messages.reduce((old, newVal) => {
          return {...old, [newVal.messageID]: newVal};
        }, this.chatMessages);

        return Object.values(this.chatMessages);
      })
    );
  }

  joinChat(operation: ITicket, chatUser: FirebaseUser): Promise<void> {
    return this.db.database.ref(`${this.usersPath}${chatUser.userID}`).update(chatUser);
  }

  async sendMessage(fromId: string, text: string, media?: any) {
    const message = new ChatMessage(fromId.toString(), text, database.ServerValue.TIMESTAMP, media);

    const id = this.messages.push(message).key;
    const updateMap = {messageID: id};
    await this.db.database.ref(this.messagesPath).child(id).update(updateMap);
  }

  sendVideocallRequest(assistance: Assistance, operatorId: string, pin: string) {
    this.firebaseService.sendVideocallRequest(assistance, operatorId, pin);
  }

  setLastKeyValue(messages: Array<IChatMessage>) {
    this.lastKey = (messages.length) ? messages[0].sentAt : this.lastKey;
  }

}
